
/*
	We're using a cooking library that isn't dependent on jQuery.cookie library, just to
	reduce dependencies.
*/

/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
!function(a){var b=!1;if(!b){var c=window.Cookies,d=window.Cookies=a();d.noConflict=function(){return window.Cookies=c,d}}}(function(){function a(){for(var a=0,b={};a<arguments.length;a++){var c=arguments[a];for(var d in c)b[d]=c[d]}return b}function b(c){function d(b,e,f){var g;if("undefined"!=typeof document){if(arguments.length>1){if(f=a({path:"/"},d.defaults,f),"number"==typeof f.expires){var h=new Date;h.setMilliseconds(h.getMilliseconds()+864e5*f.expires),f.expires=h}try{g=JSON.stringify(e),/^[\{\[]/.test(g)&&(e=g)}catch(a){}return e=c.write?c.write(e,b):encodeURIComponent(String(e)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),b=encodeURIComponent(String(b)),b=b.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),b=b.replace(/[\(\)]/g,escape),document.cookie=[b,"=",e,f.expires?"; expires="+f.expires.toUTCString():"",f.path?"; path="+f.path:"",f.domain?"; domain="+f.domain:"",f.secure?"; secure":""].join("")}b||(g={});for(var i=document.cookie?document.cookie.split("; "):[],j=/(%[0-9A-Z]{2})+/g,k=0;k<i.length;k++){var l=i[k].split("="),m=l.slice(1).join("=");'"'===m.charAt(0)&&(m=m.slice(1,-1));try{var n=l[0].replace(j,decodeURIComponent);if(m=c.read?c.read(m,n):c(m,n)||m.replace(j,decodeURIComponent),this.json)try{m=JSON.parse(m)}catch(a){}if(b===n){g=m;break}b||(g[n]=m)}catch(a){}}return g}}return d.set=d,d.get=function(a){return d.call(d,a)},d.getJSON=function(){return d.apply({json:!0},[].slice.call(arguments))},d.defaults={},d.remove=function(b,c){d(b,"",a(c,{expires:-1}))},d.withConverter=b,d}return b(function(){})});
window.FS = window.FS || {};
window.FS.Tealium = window.FS.Tealium || {};


const enrichUserFromSecurityCookie = (data = {}) => {
	data.login_state = 'anonymous';
   	data.golden_id = 'na';
    try {
        const encoded = Cookies.get('FSSecurityMX');
        if (!encoded) return data;

        const decoded =
            typeof atob === 'function' ?
            atob(encoded) :
            Buffer.from(encoded, 'base64').toString('utf-8');

        const sc = JSON.parse(decoded);


        if (sc?.goldenIdString) {
            data.user_type = 'member';
            data.golden_id = sc.goldenIdString;
        }

		if (data.golden_id === 'na' || data.golden_id == null) {
			data.golden_id = sc?.goldenIdString || 'na';
		}

        if (sc?.persisted) {
            data.login_state = 'persistent';
        } else if (sc?.authorized) {
            data.login_state = 'partially authenticated';
        } else if (sc?.valid) {
            const expired =
                sc.persistAt && new Date(sc.persistAt).getTime() < Date.now();

            data.login_state = expired ? 'persistent' : 'fully authenticated';
        }
    } catch (e) {
        console.error('Security cookie enrichment failed', e);
    }

    return data;
};



// load the tealium library async
window.FS.Tealium.loadTealium = function(config){
	(function(a,b,c,d){
  			a='//tags.tiqcdn.com/utag/'+config.account+'/'+config.profile+'/'+config.environment+'/utag.js';
  			b=document;c='script';d=b.createElement(c);d.src=a;
  			d.type='text/java'+c;d.async=true;
  			a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
	})();
};
/*
	determines whether this user is blacklisted from tracking. if
	yes, the correct values are added to the provided tealiumData.
*/
window.FS.Tealium.applyAnalyticsBlacklist= function(tealiumData, cb){
	tealiumData = tealiumData || {};

	var applyCookieValueAndCallback = function(){
		var ipCheckCookie = Cookies.getJSON('ipCheck');
		if(ipCheckCookie && ipCheckCookie.internal){
			tealiumData.is_internal = true;

			var isDev = function(){
				return (tealiumData.aa_account.indexOf('dev', tealiumData.aa_account.length - 3) !== -1);
			};

			//Do not set to fshglobalinternal if on a Dev server.  fshglobaldev is the only account that is valid on Dev servers.
			//tealiumData.is_internal will have to be used on Dev servers to indicate that the internal aa_account will be set.
			if(!(tealiumData.aa_account && isDev())){
				tealiumData.aa_account = "fshglobalinternal";
			}
		}
		cb();
	};

	//check if the blacklist has been checked in the last 24 hours
	if(Cookies.getJSON('ipCheck')){
		applyCookieValueAndCallback();
	}else{
		//need to retrieve the cookie
		$.get('/etc/designs/fourseasons/sitecatalyst-blacklist').always(function(){
			//get the value from the sitecatalyst cookie
			Cookies.set('ipCheck', {internal: !!Cookies.get('sitecatalyst-blacklist')}, {expires: 1, secure: true});
			applyCookieValueAndCallback();
		});
	}
};

/*
	If tealium is loaded when this is called called, the provided func is invoked
	immediately. Otherwise a timer is created that checks every 50 ms to see if
	tealium has been loaded. after 2000ms the function will stop checking
*/
window.FS.Tealium.attemptsConfig = {
	maxTime : 2000, //at most wait 2 seconds
	retryInterval: 50 //retry every 50 ms
};
window.FS.Tealium.attemptsConfig.maxAttempts = FS.Tealium.attemptsConfig.maxTime / FS.Tealium.attemptsConfig.retryInterval;
window.FS.Tealium.afterTealiumLoaded = function(func, attempts){
	if(window.utag){
		func();
	}else{
		attempts = attempts || 0;

		if(attempts < window.FS.Tealium.attemptsConfig.maxAttempts){
			setTimeout(function(){
				FS.Tealium.afterTealiumLoaded(func, attempts + 1);
			}, FS.Tealium.attemptsConfig.retryInterval);
		}else{
			console.error('Failed to load Tealium after ' + FS.Tealium.attemptsConfig.maxTime + ' ms. Abandoning wait.');
		}
	}
};



/**
	Wrapper for the Tealium page tracking api.
**/
window.FS.Tealium.trackPage = function(data) {
    FS.Tealium.applyAnalyticsBlacklist(data, function() {
        FS.Tealium.afterTealiumLoaded(function() {
            data = data || {};
            data = enrichUserFromSecurityCookie(data);
            try {
                data.ja_cookie = window.FS.DECISION_ENGINE.getCookie() || 'no value';
            } catch (err) {
                /*could log an error here*/ }
            try {
                if (data.event_name === "enhancement_view") {
                    data.reco_enhancement_property_name = ['na'];
                    data.reco_enhancement_name = ['na'];
                    data.reco_enhancement_sku = ['na'];
                    data.enhancement_reco_flag = ['no'];
                    data.enhancement_datalake_reco_id = ['na'];

                    let recoCookie = Cookies.get('reco-clicks');
                    if (recoCookie) {
                        recoCookie = JSON.parse(atob(recoCookie)) || {};
                    }
                    const ancillarySku = data.enhancement_sku?.[0];
                    const recoItem = recoCookie?.datalakeRecoIds?.find(x => x?.sku === ancillarySku) ?? null;
                    const isReco = !!recoItem;
                    if (isReco) {
                        data.reco_enhancement_property_name = [recoItem.ors ?? 'na'];
                        data.reco_enhancement_name = data.enhancement_name;
                        data.reco_enhancement_sku = data.enhancement_sku;
                        data.enhancement_reco_flag = ['yes'];
                        data.enhancement_datalake_reco_id = [recoItem.datalakeRecoId ?? 'na'];
                    }
                }
            } catch (err) {
                /*could log an error here*/ }
            utag.view(data);
        });
    });
};

/**
	Wrapper for the Tealium link tracking api.
**/
window.FS.Tealium.trackLink = function(eventName, data, uid) {
    data = data || {};
    data.event_name = eventName;
    if (!data.aa_account && utag_data && utag_data.aa_account) {
        data.aa_account = utag_data.aa_account;
    }
    data = enrichUserFromSecurityCookie(data);
    FS.Tealium.applyAnalyticsBlacklist(data, function() {
        FS.Tealium.afterTealiumLoaded(function() {
            if (uid) {
                utag.link(data, null, uid);
            } else {
                utag.link(data);
            }
        });
    });
}

window.FS.Tealium.needsQueryStringParam = function($el){
	var currHref = '';
	var isValidTarget = '';
	var isPageRequest = false;
	if($el && $el.length){
		currHref =  $el.attr('href');
		isValidTarget = !$el.attr('target') || $el.attr('target') === '_self';
		isPageRequest = currHref && (currHref.indexOf('http') === 0 || currHref.indexOf('//') === 0 || currHref.indexOf(':') < 0);
	}

	return isValidTarget && isPageRequest;
};

window.FS.Tealium.applyInteractionQueryStringParam = function($el, interactionValue){
	if(interactionValue && $el){
		var interactionParam = "_s_sit=" + interactionValue + "&c=t".split(' ').join('_'); //replace all spaces (without regex)
		var currHref = $el.attr('href');

		$el.attr('href', currHref + (currHref.indexOf('?') > -1 ? '&' : '?') + interactionParam);
	}
};

/* Wrapper for the trackLink function */
window.FS.Tealium.trackInteraction = function(type, name, detail, $el, extraData){
	if(FS.Tealium.needsQueryStringParam($el)){
		var interactionParam = (type || '') + "|" + (name || '') + "|" + (detail || '');
		FS.Tealium.applyInteractionQueryStringParam($el, interactionParam);
	}else{
		var interactionPayload = {interaction_type: type, interaction_name: name, interaction_detail: detail}; 
		if(extraData){
			$.extend(interactionPayload, extraData);
		}
		window.FS.Tealium.trackLink('interaction', interactionPayload);
	}
};

/*
	Automatically tracks interactions on the page if elements are
	tagged with specific values
*/
if(!window.stopTealiumAutoTracking && window.$){
	var trackByDataAttributes = function(el){
		var eventName = el.data('event-name');
		if(eventName){
			var uid = el.data('uid');
			var data = el.data('link-data');
			if(!data){
				//iterate through each attribute and look for 'data-track' prefixed items
				$.each(el[0].attributes, function() {
					if(this.specified && this.name.indexOf('data-track-') === 0) {
						data = data || {};
						data[this.name.substr(11)] = el.data(this.name.substr(5));
					}
				});
			}

			//special URL handling for interaction clicks on links that will result in the window reloading
			//in this case, stop the default behavior and just change the windows location to the a's href
			//but append the interaction query string
			if(eventName === 'interaction' && FS.Tealium.needsQueryStringParam(el)){

				var interactionParam = (data['interaction_type'] || '') + "|" + (data['interaction_name'] || '') + "|" + (data['interaction_detail'] || '');

				FS.Tealium.applyInteractionQueryStringParam(el, interactionParam);
			}else{
				FS.Tealium.trackLink(eventName, data, uid);
			}

		}
	};

	$('body').on('click', '.tealium-track', function(e){
		trackByDataAttributes($(this), e);
	});

	//check if there are any scroll tracking elements on the page
	var scrollTrackingElems = $('body').find('.tealium-track-scroll');
	if(scrollTrackingElems.length){
		var isScrolledIntoView = function(elem){
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();

			var elemTop = $(elem).offset().top;
			var elemBottom = elemTop + $(elem).height();

			//either the entire element is in view or must have scrolled at least 200 pixels in;
			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) ||
					docViewBottom >= (elemTop + 200);
		};

		//attach a listener to the page
		$(window).scroll(function(){
			//check to see if each of the elements are in view
			scrollTrackingElems.each(function (i, element){
				var $element = $(element);
				if(isScrolledIntoView($element) && !$element.data('tealium-scroll-tracked')){
					//mark that it's been scrolled too
					$element.data('tealium-scroll-tracked', true);
					trackByDataAttributes($element);
				}
			});
		});
	}
}

/*
	Allow for a deferred invokation. Works similar to the Google Maps api.
	Will look for a global funtion called 'onTealiumLibraryLoaded' and invoke
*/
if(window.onTealiumLibraryLoaded){
	window.onTealiumLibraryLoaded();
}


/******************************************************************************/
/** youtube tracking **********************************************************/
/**
 * onYouTubePlayerReady
 *
 * The default callback when the JS API is enabled
 */
FS.Tealium.onYouTubePlayerReady = function(event, options){
	var youTubePlayer = event.target;

    // List the various player states for easy use later
    var youTubePlayerStates = {
        unstarted:      -1,
        finished:       0,
        playing:        1,
        paused:         2,
        buffering:      3,
        cued:           5
    };

    var youtubeId = youTubePlayer.getVideoUrl().split('v=')[1];
    var ampersandPosition = youtubeId.indexOf('&');
    if(ampersandPosition != -1) {
    	youtubeId = youtubeId.substring(0, ampersandPosition);
    }

    var videoName = youTubePlayer.getVideoData().title || youtubeId;
    //var videoName = jQuery('li.asset-wrapper.selected div.caption-info h2.asset-name').html().replace(/^\s+|\s+$/g,'').toLowerCase();
    var videoDuration = youTubePlayer.getDuration();

    var getName = function(name){
		return options && options.namePrefix ? options.namePrefix + name : name;
	};

    // Create a new array element for the video
    var youTubePlayerCallback = {
        played:         false,                          // Has the video started yet?
        completed:      false,                          // Has the video finished playing?
        name:           getName(videoName),                      // The name of the video
        duration:       videoDuration,                  // Can't get until
        previousState:  youTubePlayerStates.unstarted,  // Previous state, defaults to unstarted
		previousTime:   0,                              // Previous time, defaults to 0 (not started)
		watchingTimer: false,
		milestones: {
			"25": Math.floor(videoDuration / 4),
			"50": Math.floor(videoDuration / 2),
			"75": Math.floor(videoDuration * .75)
		},
		checkMilestones: function(){
			//is the video playing?
			if(youTubePlayer.getPlayerState() === 1){
				var currentTime = Math.floor(youTubePlayer.getCurrentTime());
				var trackingData = youTubePlayerCallback.getDefaultTrackingData();

				Object.entries(youTubePlayerCallback.milestones).forEach(function(value) {
					var key = value[0], 
					value = value[1];
					if(currentTime === value){
						trackingData.video_milestone_ID = key;
						FS.Tealium.trackLink('video_milestone',trackingData);
						return false;
					}
				});
			}
		},
		getDefaultTrackingData: function(){
			return {
				'video_name':youTubePlayerCallback.name,
				'video_length': youTubePlayerCallback.duration,
				'video_player': 'youtube'
			}
		},
        stateChange: function (newState)
        {
            // Grab the current state
            var currentState = youTubePlayer.getPlayerState();

            // Get the current position to the nearest next second
            var currentTime = Math.ceil(youTubePlayer.getCurrentTime());

            // Figure out what state we are in
            switch(currentState)
            {
                // Video has been initialized, but not started
                case youTubePlayerStates.unstarted:
                    break;

                // Video finished
                case youTubePlayerStates.finished:
                    // Show that we have indeed completed the video
                	youTubePlayerCallback.completed = true;
                	FS.Tealium.trackLink('video_complete',youTubePlayerCallback.getDefaultTrackingData());

					clearInterval(youTubePlayerCallback.watchingTimer);
					break;


                // Video started to play
                case youTubePlayerStates.playing:
                    // This video has never been played before
                    if(!youTubePlayerCallback.played) {
                        // Show that we have started to play the video
						youTubePlayerCallback.played = true;
                    	FS.Tealium.trackLink('video_start',youTubePlayerCallback.getDefaultTrackingData());

						//start a timer to keep track of milestones
						youTubePlayerCallback.watchingTimer = setInterval(youTubePlayerCallback.checkMilestones, 1000);
                    } else if(youTubePlayerCallback.played && youTubePlayerCallback.completed) {
                        // The video has been played before, and has recently finished (replay)
                        // Show that we haven't finished the video yet (since we just started watching it again)
                    	youTubePlayerCallback.completed = false;
                    } else {
						// Video Unpaused/played from buffering
						//start a timer to keep track of milestones
						youTubePlayerCallback.watchingTimer = setInterval(youTubePlayerCallback.checkMilestones, 1000);
                    }
                    break;

                // Video has been paused
				case youTubePlayerStates.paused:
					clearInterval(youTubePlayerCallback.watchingTimer);
                    break;

                // Video is now buffering
				case youTubePlayerStates.buffering:
					clearInterval(youTubePlayerCallback.watchingTimer);
                    break;

                // Video is cued up from a playlist
                case youTubePlayerStates.cued:
                    break;

                // new / unknown state
                default:
                    break;
            }

            // Setup our previous youTubePlayerStates for the next call
            this.previousTime = currentTime;
            this.previousState = currentState;
        }
    };

    // Add an event listener for changes in the player's state
    if (youTubePlayer.addEventListener) {
      youTubePlayer.addEventListener("onStateChange", youTubePlayerCallback.stateChange);
    }
}
/******************************************************************************/
/******************************************************************************/
/** vimeo tracking **********************************************************/
/**
 * on vimeo player ready
 *
 */
 FS.Tealium.onVimeoPlayerReady = function(player, options){
 	var playerState = {
		playing: false,
		completed: false
	};

	var getName = function(title){
		return options && options.namePrefix ? options.namePrefix + title : title;
	};

	player.on('play', function(){
		if(!playerState.playing){
			playerState.playing = true;
			player.getVideoTitle().then(function(title){

				window.FS.Tealium.trackLink('video_start',{'video_name':getName(title)});
			});
		}else if(playerState.playing && playerState.completed){
			playerState.completed = false;
		}
	});

	player.on('ended', function(){
		playerState.completed = true;
		player.getVideoTitle().then(function(title){
			window.FS.Tealium.trackLink('video_complete',{'video_name':getName(title)});
		});

	});


 };

const utmCaptureParameters = () => {
	const utmCookie = 'utm_parameters';
	const params = ['cm_cat', 'cm_ven', 'utm_campaign', 'utm_medium', 'utm_source', 'testver'];
	let adsCookiesAllowed = false;
	let hasUtmCookie = true;
	let hasUtmParameters = false;
	let utmJson = {};
	if (!Cookies.get(utmCookie)) {
		hasUtmCookie = false;
		const qs = Object.fromEntries(new URLSearchParams(window.location.search).entries()) || {};
		utmJson = params.reduce((utmAcc, param) => {
			if (qs[param]) {
				utmAcc[param] = qs[param];
			}
			return utmAcc;
		}, {});
		hasUtmParameters = Object.keys(utmJson).length;
	}

	const utmSetCookie = () => {
		try {
			if (adsCookiesAllowed) {
				Cookies.set(utmCookie, JSON.stringify(utmJson), { secure: true });
			} else {
				if (Cookies.get(utmCookie)) {
					Cookies.set(utmCookie, {}, { secure: true, expires: 0 });
				}
			}
		} catch (e) {
			//console.log('utmSetCookie error', e);
		}
	};

	try {
		if (hasUtmParameters) {
			window.FS.GDPR.getSavedConsent(groups => {
				adsCookiesAllowed = groups['ads'];
				utmSetCookie();
			});
		}
		if (hasUtmCookie || hasUtmParameters) {
			window.FS.GDPR.onConsentChange(groups => {
				adsCookiesAllowed = groups['ads'];
				utmSetCookie();
			});
		}
	} catch (e) {
		//console.log('utmCaptureParameters error', e);
	}
}
utmCaptureParameters();
